import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import PageLayout from "../components/layout/PageLayout";
import { useAuth, formatApiError } from "../lib/auth";
import { LOGO_GOLD } from "../lib/constants";

const ROLES = [
    { v: "athlete", l: "I'm an Athlete" },
    { v: "sponsor", l: "I'm a Brand / Sponsor" },
    { v: "guardian", l: "I'm a Parent / Guardian" },
];

export default function Register() {
    const nav = useNavigate();
    const [params] = useSearchParams();
    const { register } = useAuth();
    const [form, setForm] = useState({ name: "", email: "", password: "", role: params.get("role") || "athlete" });
    const [busy, setBusy] = useState(false);
    const setF = (k, v) => setForm(f => ({ ...f, [k]: v }));

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            const user = await register(form);
            toast.success(`Welcome to Digital Beast, ${user.name}`);
            const dest = user.role === "sponsor" ? "/sponsor/dashboard" : "/athlete/dashboard";
            nav(dest);
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setBusy(false);
        }
    };

    return (
        <PageLayout noFooter>
            <section className="min-h-[calc(100vh-68px)] flex items-center py-16">
                <div className="max-w-md mx-auto w-full px-5">
                    <div className="text-center mb-10">
                        <img src={LOGO_GOLD} alt="Digital Beast" className="h-14 mx-auto" />
                        <h1 className="font-display text-4xl text-white mt-6 tracking-tight" data-testid="register-heading">JOIN THE PACK</h1>
                    </div>
                    <form onSubmit={submit} className="surface p-8 space-y-5" data-testid="register-form">
                        <div>
                            <label className="db-label">Full Name</label>
                            <input required className="db-input-block" value={form.name} onChange={e => setF("name", e.target.value)} data-testid="register-name" />
                        </div>
                        <div>
                            <label className="db-label">Email</label>
                            <input type="email" required className="db-input-block" value={form.email} onChange={e => setF("email", e.target.value)} data-testid="register-email" />
                        </div>
                        <div>
                            <label className="db-label">Password (min 6 chars)</label>
                            <input type="password" minLength={6} required className="db-input-block" value={form.password} onChange={e => setF("password", e.target.value)} data-testid="register-password" />
                        </div>
                        <div>
                            <label className="db-label">Account Type</label>
                            <div className="grid grid-cols-3 gap-2">
                                {ROLES.map(r => (
                                    <button key={r.v} type="button" onClick={() => setF("role", r.v)}
                                        className={`chip justify-center ${form.role === r.v ? "chip-active" : ""}`}
                                        data-testid={`register-role-${r.v}`}>{r.l}</button>
                                ))}
                            </div>
                        </div>
                        <button type="submit" disabled={busy} className="btn-gold w-full justify-center" data-testid="register-submit">
                            {busy ? "Creating account…" : "Create Account"}
                        </button>
                        <div className="text-center text-sm text-white/50">
                            Already have an account? <Link to="/login" className="text-[#d4af37] hover:underline" data-testid="register-login-link">Sign in</Link>
                        </div>
                    </form>
                </div>
            </section>
        </PageLayout>
    );
}
